"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const actionTypes = require("../../actionTypes/distribution/recipients");
exports.initialState = {
    list: {
        status: 'STANDBY'
    },
    selected: []
};
//#region LENS
const listLens = monocle.Lens.fromProp('list');
const selectionLens = monocle.Lens.fromProp('selected');
//#endregion
//#region REDUCER METHODS
const methods = {};
exports.methods = methods;
methods[actionTypes.FETCH_REQUEST] = (state, action) => listLens.set({ status: 'FETCHING' })(state);
methods[actionTypes.FETCH_SUCCESS] = (state, action) => listLens.set({ status: 'FETCHED', users: action.payload })(state);
methods[actionTypes.FETCH_FAILED] = (state, action) => listLens.set({ status: 'FAILED', error: action.payload })(state);
methods[actionTypes.SELECT] = (state, action) => selectionLens.modify((list) => action.payload.ids.reduce((r, i) => {
    if (r.indexOf(i) === -1)
        return [...r, i];
    return r;
}, list))(state);
methods[actionTypes.UNSELECT] = (state, action) => selectionLens.modify((selected) => selected.filter((id) => action.payload.ids.indexOf(id) === -1))(state);
methods[actionTypes.CLEAR] = (state) => (Object.assign({}, exports.initialState));
//#endregion
//# sourceMappingURL=recipients.js.map